import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, BookOpen, Droplet, Ban, Calendar, Pill } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function DeliverablesSection() {
  const items = [{
    icon: <BookOpen className="w-6 h-6 text-emerald" data-id="element-35" />,
    title: 'El Manual Principal: Detox de Inflamación Celular',
    desc: 'PDF de lectura rápida y profunda.'
  }, {
    icon: <Droplet className="w-6 h-6 text-emerald" data-id="element-36" />,
    title: 'La Receta del Suero Maestro',
    desc: 'La mezcla exacta para hidratar tus órganos en 240 horas.'
  }, {
    icon: <Ban className="w-6 h-6 text-emerald" data-id="element-37" />,
    title: 'Lista Negra de Alimentos Latinos',
    desc: 'Qué ingredientes de tu despensa están saboteando tus rodillas hoy mismo.'
  }, {
    icon: <Calendar className="w-6 h-6 text-emerald" data-id="element-38" />,
    title: 'El Plan de 10 Días',
    desc: 'Menú detallado paso a paso para eliminar la hinchazón.'
  }, {
    icon: <Pill className="w-6 h-6 text-emerald" data-id="element-39" />,
    title: 'Guía de Suplementación Inteligente',
    desc: 'Solo lo que funciona (Magnesio y Cúrcuma).'
  }];
  return <section className="py-20 bg-white" data-id="element-40">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-41">
        <FadeIn data-id="element-42">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-forest mb-12" data-id="element-43">
            Todo lo que recibes hoy
          </h2>
        </FadeIn>

        <div className="bg-sand/20 rounded-3xl p-6 md:p-10 border border-sand/50" data-id="element-44">
          <div className="space-y-6" data-id="element-45">
            {items.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-46">
                <div className="flex items-start gap-4 bg-white p-5 rounded-2xl shadow-sm" data-id="element-47">
                  <div className="bg-emerald/10 p-3 rounded-full flex-shrink-0" data-id="element-48">
                    {item.icon}
                  </div>
                  <div data-id="element-49">
                    <h4 className="font-bold text-forest text-lg" data-id="element-50">
                      {item.title}
                    </h4>
                    <p className="text-gray-600 text-sm mt-1" data-id="element-51">{item.desc}</p>
                  </div>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.6} className="mt-10 text-center" data-id="element-52">
            <CTAButton data-id="element-53" />
          </FadeIn>
        </div>
      </div>
    </section>;
}